<script lang="ts">
	import { contactId } from "@core/schema/ids/contactId.js";
	import { getCataloguePath } from "@core/schema/paths/getCataloguePath.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";
	import type { ProductProps } from "../../templates/ProductProps.js";
	import translations from "../../templates/product.translations.json" with { type: "json" };
	import { getTranslate } from "../../utils/getTranslate.js";
	import Formatted from "../common/Formatted.svelte";
	import Link from "../common/Link.svelte";
	import TextWithIcon from "../common/TextWithIcon.svelte";
	import { ButtonVariant } from "../common/getButtonClass.js";

	const {
		product,
	}: {
		product: ProductProps["product"];
	} = $props();
	const { tenant } = getGlobalTemplateProps();
	const translate = getTranslate(translations);
</script>

<div class="flex flex-col flex-1">
	<h1 class="text-[32px]/[1.2] font-semibold text-zms-blue md:mb-8 mb-6">
		<Formatted text={product.name} />
	</h1>

	{#if product.perex}
		<p class="font-normal text-md/[1.35] lg:text-lg/[1.4] text-optical-black">
			<Formatted text={product.description} />
		</p>
	{/if}

	{#if product.parameters.length > 0}
		<div class="md:my-16 my-10">
			<div>
				<table class="w-full">
					<tbody>
						{#each product.parameters as parameter (parameter.name)}
							<tr class="border-t border-zms-blue">
								<td class="px-6 py-6 text-sm text-zms-blue">
									{parameter.name}
								</td>
								<td class="px-6 py-6 text-sm text-zms-optical-black font-semibold">
									{parameter.value}
								</td>
							</tr>
						{/each}
					</tbody>
				</table>
			</div>
		</div>
	{/if}

	<div class="flex sm:flex-row flex-col justify-between items-center gap-6 sm:gap-4 px-2">
		<Link href="#{contactId[tenant.locale]}" variant={ButtonVariant.OutlinedWithIcon}>
			<TextWithIcon>{translate("getPriceButton")}</TextWithIcon>
		</Link>
		<Link href={getCataloguePath(tenant.locale)} class="uppercase" variant={ButtonVariant.TransparentWithIcon}>
			<TextWithIcon>{translate("backToCatalogue")}</TextWithIcon>
		</Link>
	</div>
</div>
